interface TodayLoaderProps {
  /** Render the "nothing to show" message instead of the spinner. */
  empty?: boolean
}

/** Loading / empty state shared by the Today categories. */
export function TodayLoader({ empty }: TodayLoaderProps) {
  if (empty) {
    return (
      <div className="flex min-h-[40dvh] flex-col items-center justify-center gap-2 px-8 text-center">
        <p className="font-display text-xl font-medium text-purple-light">Not available yet</p>
        <p className="font-body text-sm text-purple-light/60">
          Complete your profile to unlock today’s reading, then check back.
        </p>
      </div>
    )
  }

  return (
    <div className="flex min-h-[40dvh] items-center justify-center">
      <span className="size-8 animate-spin rounded-full border-2 border-purple-light/20 border-t-main-purple" />
    </div>
  )
}
